import React from 'react';
import { Box, Typography } from '@mui/material';
import styles from './footer.module.css';
import lion from "../../images/lion.svg";

const NewFooter = () => {
    return (
        <Box className={styles.instruction_paragraph_container}>
            <Box className={styles.lioncontainer}>
                <img src={lion} className={styles.lion} alt="Lion Logo" />
            </Box>
        </Box>
    );
};

export default NewFooter;
